package com.jingfangpai.diagnosisSetting.model

import com.jingfangpai.common.orm.mapping.SignSymptomSettingAccompaniedBy
import com.jingfangpai.common.orm.mapping.enums.SignSymptomName
import kotlinx.serialization.Serializable

@Serializable
class SignSymptomSettingAccompaniedByDto: SignSymptomSettingAccompaniedBy() {
    var accompaniedSymptomName:SignSymptomName? = null
    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other == null || this::class != other::class) return false
        if (!super.equals(other)) return false

        other as SignSymptomSettingAccompaniedByDto

        if (accompaniedSymptomName != other.accompaniedSymptomName) return false

        return true
    }

    override fun hashCode(): Int {
        var result = super.hashCode()
        result = 31 * result + (accompaniedSymptomName?.hashCode() ?: 0)
        return result
    }


}